import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import {
  productAssetImageInner,
  VIDEO_TYPE
} from '../../../../constants/constants';
import imageCropOptions from '../../../../constants/imageCropOptions';
import ImageZoom from '../details/ImageZoom';
import Video from '../Video';

const CONTAINER_ID = 'ols-image-wrapper';
const CONTAINER_IMAGE_MULTIPLIER = 2;
class DesktopAssets extends Component {
  state = { wrapperStyle: {} };

  wrapper = {};

  componentDidMount() {
    this.wrapper = document.getElementById(CONTAINER_ID);
    window.addEventListener('resize', this.resizeWrapper);
    this.resizeWrapper();
  }

  componentDidUpdate(prevProps) {
    const cropMethodChanged = prevProps.zoomConfig.cropMethod !== this.props.zoomConfig.cropMethod;
    const aspectRatioChanged = prevProps.aspectRatio !== this.props.aspectRatio;

    if (aspectRatioChanged || cropMethodChanged) {
      this.resizeWrapper();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeWrapper);
  }

  resizeWrapper = () => {
    const width = this.wrapper ? this.wrapper.offsetWidth : 0;

    if (width > 0) {
      const height = width / this.props.aspectRatio;
      this.setState(state => ({
        ...state,
        wrapperStyle: { height }
      }));
    }
  };

  get style() {
    return {
      ...productAssetImageInner,
      ...this.zoom.containerStyle,
      ...this.state.wrapperStyle
    };
  }

  get zoom() {
    const { containerStyle, ...config } = this.props.zoomConfig;
    return { containerStyle, config };
  }

  render() {
    const { Block } = UX2.Element;
    const { aspectRatio, selectedAsset, product } = this.props;
    let { currentAssetUrl, zoomAssetUrl } = selectedAsset;

    if (currentAssetUrl) {
      // Change default height and width from old flow to new flow for images loaded.
      currentAssetUrl = currentAssetUrl.replace('w:600,h:600', 'w:1200,h:1200');
    }

    const { attachmentWidth, attachmentHeight } = selectedAsset;
    const assetApiUrl = /[rs=w:](\d+)/.exec(currentAssetUrl);
    const { offsetWidth: availableWrapperWidth = 0, offsetHeight: availableWrapperHeight = 0 } = this.wrapper || {};

    if (aspectRatio && !!assetApiUrl) {
      const curSize = +assetApiUrl[1];
      const imageWidth = Math.min(availableWrapperWidth * CONTAINER_IMAGE_MULTIPLIER, attachmentWidth);
      const imageHeight = Math.min(availableWrapperHeight * CONTAINER_IMAGE_MULTIPLIER, attachmentHeight);

      if (this.zoom.config.cropMethod === imageCropOptions.EXPAND_TO_FILL) {
        currentAssetUrl = currentAssetUrl.replace(`w:${curSize},h:${curSize}`, `w:${curSize},h:${curSize},cg:true`);
      } else {
        currentAssetUrl = currentAssetUrl.replace(`w:${curSize},h:${curSize}`, `w:${imageWidth},h:${imageHeight}`);
      }
    }

    const zoomApiUrl = /[rs=w:](\d+)/.exec(zoomAssetUrl);
    if (zoomApiUrl) {
      const curSize = +zoomApiUrl[1];
      zoomAssetUrl = zoomAssetUrl.replace(`w:${curSize},h:${curSize}`, `w:${attachmentWidth},h:${attachmentHeight},cg:true`);
    }

    return (
      <Block id={ CONTAINER_ID } style={ this.style } >
        {selectedAsset.type === VIDEO_TYPE
          ? <Video videoUrl={ currentAssetUrl } />
          : (
            <ImageZoom
              src={ currentAssetUrl }
              srcLarge={ zoomAssetUrl }
              zoomDimensions={ [attachmentWidth, attachmentHeight] }
              alt={ product.name }
              containerId={ CONTAINER_ID }
              aspectRatio={ aspectRatio }
              { ...this.zoom.config }
              disableZoom={ availableWrapperHeight >= attachmentHeight || availableWrapperWidth >= attachmentWidth  }
            />
          )}
      </Block>
    );
  }
}

DesktopAssets.defaultProps = {
  aspectRatio: null,
  product: {},
  selectedAsset: {},
  zoomConfig: {}
};

DesktopAssets.propTypes = {
  aspectRatio: PropTypes.number,
  product: PropTypes.object,
  selectedAsset: PropTypes.object,
  zoomConfig: PropTypes.object
};

export default DesktopAssets;
